import { Grid, TableCell } from '@mui/material';
import { STTableProp, STTableColumnDetail } from '../STTableProps';
import {
    Checkbox,
} from "@mui/material";
import TableMenu from './TableMenu';
import TableSort from './TableSort';
import './CustomStyleST.css';
import { ParseHtml } from 'utilities/utilities';
// import { ParseHtml } from 'src/utilities/utilities';

export default function TableColumn(param: STTableProp, item: STTableColumnDetail, selectHead, setSelectHead) {
    return <TableCell height={"45px"} padding={"none"} align={"center"} key={param.sTableID + "_" + item.field + "_row"}
        style={item.width ? { width: item.width } : {}}
        className={param.classHead ? param.classHead : "tbcustomcell"} >
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={'th-cell-box'}
        >

            <Grid xs={10}
                justifyContent="center"
                alignItems="center" textAlign="center" item={true}
            // style={{maxWidth:"300px"}}
            >
                {
                    item.sortable === true && !item.isCheckBox && !item.renderHeader ? TableSort(param, item) : item.isCheckBox ?

                        <Checkbox
                            id={"ckHead_" + param.sTableID}
                            disabled={param.isView}
                            checked={selectHead}
                            sx={{ color: "white" }}
                            onChange={(e) => {
                                setSelectHead(!selectHead)
                            }}

                        />
                        :
                        item.renderHeader ? item.renderHeader() : ParseHtml(item.headerName)

                }
            </Grid>
            {
                param.isMenu && item.isSort !== false ?
                    <Grid xs={2} item={true}
                        textAlign="right"
                    >
                        {TableMenu(param, item)}
                    </Grid>
                    : null
            }

        </Grid>

    </TableCell>
}